var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDividerVertical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 18,
    viewBox: "0 0 1 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 1.08152e-8,
    x2: 0.499999,
    y2: 18,
    stroke: "#E3E8EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerVertical);
export default __webpack_public_path__ + "static/media/divider-vertical.66a980af28a187a94d74d73225404cd9.svg";
export { ForwardRef as ReactComponent };